const getParameterByName = (name, url) => {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
  const results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

// Landbruksdirektoratet token to log in:
export let token = '';
export const setToken = (t) => token = t;

export const getApplicationToken = (ar5) => {
  return ar5 ? '' : '?token=' + getParameterByName('token');
};

// Geonorge token to access WMTS base maps:
let gToken; // will be used for minimaps too;
export const setGeonorgeToken = (t) => gToken = t;
export const getGeonorgeToken = () => gToken;

let nibToken; // will be used to fetch nib projects
// Geonorge token to access cached WMTSes:
export const requestNibToken = (ny) => new Promise((resolve, reject) => {
  if (ny) nibToken = null;
  resolve(nibToken ??
    fetch(`https://${import.meta.env.VITE_PROXY}/config_ws/config`)
      .then(r => r.json()).then(json => json.value)
      .catch(() => console.log('Token fra Geonorge kunne ikke hentes.'))
  );
});
